
import *  as axios from 'axios';
import * as ActionTypesBO from '../../constants/actiontypes/backoffice/user';
import * as ActionTypesUser from '../../constants/actiontypes/user';
import * as DeathDeclarationActionTypes from '../../constants/actiontypes/facilita/deathDeclaration';
import * as PartnerActionTypes from '../../constants/actiontypes/partner/partner';
import * as PartnerUrl from '../../constants/webapi/partner/partner';
import * as userUrls from '../../constants/webapi/user';
import * as urlsFacilita from '../../constants/webapi/facilita';
import { getAuthenticationUrl } from '../../constants/webapi/auth';


export function resetDetailUser() {
    return ({ type: ActionTypesBO.RESET_BACKOFFICER_USER_STATE });
}

export function fetchUserById(id) {
    return (dispatch) => {
        dispatch({ type: ActionTypesBO.FETCH_BACKOFFICE_USER_REQUEST, id: id });
        return axios.get(userUrls.userByIdUrl(id))
            .then((response) => {
                dispatch({
                    type: ActionTypesBO.FETCH_BACKOFFICE_USER_SUCCESS,
                    data: response.data
                });
            })
            .catch((error) => {
                if (error.response !== undefined && error.response.status === 401) {
                    window.location = getAuthenticationUrl();
                    return;
                }
                dispatch({
                    type: ActionTypesBO.FETCH_BACKOFFICE_USER_FAILURE,
                    response: error.response
                });
                throw error.statusText;
            });
    };
}

export function fetchUserInvoicesById(id) {
    return (dispatch) => {
        dispatch({ type: ActionTypesBO.FETCH_BACKOFFICE_USER_INVOICES_REQUEST, id: id });
        return axios.get(userUrls.getRecipientInvoicesByIdUrl(id))
            .then((response) => {
                dispatch({
                    type: ActionTypesBO.FETCH_BACKOFFICE_USER_INVOICES_SUCCESS,
                    data: response.data
                });
            })
            .catch((error) => {
                if (error.response !== undefined && error.response.status === 401) {
                    window.location = getAuthenticationUrl();
                    return;
                }
                dispatch({
                    type: ActionTypesBO.FETCH_BACKOFFICE_USER_INVOICES_FAILURE,
                    response: error.response
                });
                throw error.statusText;
            });
    };
}

export function getUserServices(user) {
    return (dispatch) => {
        dispatch({ type: ActionTypesBO.FETCH_BACKOFFICE_USER_SERVICES_REQUEST, user: user.id });
        return axios.get(userUrls.userServicesUrl(user.id))
            .then((response) => {
                dispatch({
                    type: ActionTypesBO.FETCH_BACKOFFICE_USER_SERVICES_SUCCESS,
                    data: response.data
                });
            })
            .catch((error) => {
                if (error.response !== undefined && error.response.status === 401) {
                    window.location = getAuthenticationUrl();
                    return;
                }
                dispatch({
                    type: ActionTypesBO.FETCH_BACKOFFICE_USER_SERVICES_FAILURE,
                    response: error.response
                });
                throw error.statusText;
            });
    };
}

export function getUserServiceData(userId, serviceType) {
    return (dispatch) => {
        dispatch({ type: DeathDeclarationActionTypes.FETCH_USER_SERVICES_DATA_REQUEST, user: userId });
        return axios.get(userUrls.userServiceDataUrl(userId, serviceType))
            .then((response) => {
                dispatch({
                    type: DeathDeclarationActionTypes.FETCH_USER_SERVICES_DATA_SUCCESS,
                    data: response.data
                });
            })
            .catch((error) => {
                if (error.response !== undefined && error.response.status === 401) {
                    window.location = getAuthenticationUrl();
                    return;
                }
                dispatch({
                    type: DeathDeclarationActionTypes.FETCH_USER_SERVICES_DATA_FAILURE,
                    response: error.response
                });
                throw error.statusText;
            });
    };
}


export function getDocuments(user) {
    return (dispatch) => {
        dispatch({ type: ActionTypesUser.FETCH_DOCUMENTS_REQUEST, user: user.id });
        return axios.get(userUrls.userDocumentsUrl(user.id))
            .then((response) => {
                dispatch({
                    type: ActionTypesUser.FETCH_DOCUMENTS_SUCCESS,
                    data: response.data,
                });
            })
            .catch((error) => {
                if (error.response !== undefined && error.response.status === 401) {
                    window.location = getAuthenticationUrl();
                    return;
                }
                dispatch({
                    type: ActionTypesUser.FETCH_DOCUMENTS_FAILURE,
                    response: error.response
                });
                throw error.statusText;
            });
    };
}

export function getUserAddress(userId) {
    return (dispatch) => {
        dispatch({ type: ActionTypesUser.FETCH_USER_ADDRESS_REQUEST, user: userId });
        return axios.get(userUrls.userAddressByIdUrl(userId))
            .then((response) => {
                dispatch({
                    type: ActionTypesUser.FETCH_USER_ADDRESS_SUCCESS,
                    data: response.data
                });
            })
            .catch((error) => {
                if (error.response !== undefined && error.response.status === 401) {
                    window.location = getAuthenticationUrl();
                    return;
                }
                dispatch({
                    type: ActionTypesUser.FETCH_USER_ADDRESS_FAILURE,
                    response: error.response
                });
                throw error.statusText;
            });
    };
}


export function getUserConnections(userId) {
    return (dispatch) => {
        dispatch({ type: ActionTypesUser.FETCH_USER_SERVICES_REQUEST, user: userId });
        return axios.get(urlsFacilita.userConnectionsUrl(userId))
            .then((response) => {
                dispatch({
                    type: ActionTypesUser.FETCH_USER_SERVICES_SUCCESS,
                    data: response.data
                });
            })
            .catch((error) => {
                if (error.response !== undefined && error.response.status === 401) {
                    window.location = getAuthenticationUrl();
                    return;
                }
                dispatch({
                    type: ActionTypesUser.FETCH_USER_SERVICES_FAILURE,
                    response: error.response
                });
                throw error.statusText;
            });
    };
}


export function getLettersForUserId(userId) {
    return (dispatch) => {
        dispatch({ type: DeathDeclarationActionTypes.FETCH_USER_LETTERS_REQUEST, userId: userId });
        return axios.get(urlsFacilita.userLetterUrlByUserId(userId))
            .then((response) => {
                dispatch({
                    type: DeathDeclarationActionTypes.FETCH_USER_LETTERS_SUCCESS,
                    userId: userId,
                    letters: response.data
                });
            })
            .catch((error) => {
                dispatch({
                    type: DeathDeclarationActionTypes.FETCH_USER_LETTERS_FAILURE,
                    response: error.response,
                    userId: userId
                });
                throw error.statusText;
            });
    };
}

export function unvalidateLetter(userletter) {
    return (dispatch) => {
        dispatch({ type: DeathDeclarationActionTypes.UPDATE_USER_LETTER_REQUEST, userletterId: userletter.id });
        return axios.put(urlsFacilita.userletterUrlByletterId(userletter.id) + "/unvalidate")
            .then((response) => {
                dispatch({
                    type: DeathDeclarationActionTypes.UPDATE_USER_LETTER_SUCCESS,
                    userletterId: userletter.id,
                    userletter: response.data
                });
            })
            .catch((error) => {
                dispatch({
                    type: DeathDeclarationActionTypes.UPDATE_USER_LETTER_FAILURE,
                    response: error.response,
                    userletterId: userletter.id
                });
                throw error.statusText;
            });
    };
}


export function getUserRepresentatives(userId) {
    return (dispatch) => {
        dispatch({ type: ActionTypesUser.FETCH_REPRESENTATIVES_REQUEST });
        return axios.get(userUrls.userRepresentativesUrlById(userId))
            .then((response) => {
                dispatch({
                    type: ActionTypesUser.FETCH_REPRESENTATIVES_SUCCESS,
                    data: response.data
                });
            })
            .catch((error) => {
                if (error.response !== undefined && error.response.status === 401) {
                    window.location = getAuthenticationUrl();
                    return;
                }
                dispatch({
                    type: ActionTypesUser.FETCH_REPRESENTATIVES_FAILURE,
                    response: error.response
                });
                throw error.statusText;
            });
    };
}


export function createDeathDeclaration(userId, deathDeclaration) {
    return (dispatch) => {
        dispatch({ type: DeathDeclarationActionTypes.CREATE_DECLARATION_REQUEST });
        return axios.post(userUrls.declareDeathById(userId), deathDeclaration)
            .then((response) => {
                dispatch({
                    type: DeathDeclarationActionTypes.CREATE_DECLARATION_SUCCESS,
                    data: response.data,
                });
                return response.data;
            })
            .catch((error) => {

                if (error.response !== undefined && error.response.status === 401) {
                    window.location = getAuthenticationUrl();
                    return;
                }
                dispatch({
                    type: DeathDeclarationActionTypes.CREATE_DECLARATION_FAILURE,
                    response: error.response,
                    // referentId: id
                });
                throw error.statusText;
            });
    };
}

export function getDeathDeclaration(userId, defaultValues) {
    return (dispatch) => {
        dispatch({ type: DeathDeclarationActionTypes.FETCH_DECLARATION_REQUEST });
        return axios.get(userUrls.declareDeathById(userId))
            .then((response) => {
                dispatch({
                    type: DeathDeclarationActionTypes.FETCH_DECLARATION_SUCCESS,
                    data: response.data
                });
                return response.data;
            })
            .catch((error) => {
                if (error.response !== undefined) {
                    if (error.response.status === 401) {
                        window.location = getAuthenticationUrl();
                        return;
                    }
                    if (error.response.status === 404) {
                        dispatch({
                            type: DeathDeclarationActionTypes.FETCH_DECLARATION_SUCCESS,
                            data: {},
                            defaultValues
                        });
                        return "NotFound";
                    }
                }
                dispatch({
                    type: DeathDeclarationActionTypes.FETCH_DECLARATION_FAILURE,
                    response: error.response,
                    // referentId: id
                });
                throw error.statusText;
            });
    };
}

export function inviteUserRepresentative(userRepresentativeId) {
    return (dispatch) => {
        dispatch({ type: DeathDeclarationActionTypes.REPRESENTATIVE_INVITATION_REQUEST });
        return axios.post(urlsFacilita.userRepresentativesInvitationByIdUrl(userRepresentativeId))
            .then((response) => {
                dispatch({
                    type: DeathDeclarationActionTypes.REPRESENTATIVE_INVITATION_SUCCESS,
                    data: response.data
                });
                return response.data;
            })
            .catch((error) => {
                if (error.response !== undefined) {
                    if (error.response.status === 401) {
                        window.location = getAuthenticationUrl();
                        return;
                    }
                    if (error.response.status === 404) {
                        dispatch({
                            type: DeathDeclarationActionTypes.REPRESENTATIVE_INVITATION_FAILURE,
                            data: {},
                        });
                        return "NotFound";
                    }
                }
                dispatch({
                    type: DeathDeclarationActionTypes.REPRESENTATIVE_INVITATION_FAILURE,
                    response: error.response,
                    // referentId: id
                });
                throw error.statusText;
            });
    };
}

export function closeDossier(userId, user) {
    return (dispatch) => {
        dispatch({ type: ActionTypesBO.DELETE_BACKOFFICE_USER_REQUEST, user: userId });
        return axios.delete(userUrls.userSoftDeleteByIdUrl(userId), user)
            .then(() => {
                dispatch({
                    type: ActionTypesBO.DELETE_BACKOFFICE_USER_SUCCESS,
                    user: user,
                    userId: userId
                });
            })
            .catch((error) => {
                if (error.response !== undefined && error.response.status === 401) {
                    window.location = getAuthenticationUrl();
                    return;
                }
                dispatch({
                    type: ActionTypesBO.DELETE_BACKOFFICE_USER_FAILURE,
                    response: error.response
                });
                throw error.statusText;
            });
    };
}

export function GetPartnerById(partnerId) {
    return (dispatch) => {
        dispatch({ type: PartnerActionTypes.FETCH_PARTNER_REQUEST });
        return axios.get(PartnerUrl.partnerByIdUrl(partnerId))
            .then((response) => {
                dispatch({
                    type: PartnerActionTypes.FETCH_PARTNER_SUCCESS,
                    data: response.data
                });
            })
            .catch((error) => {
                if (error.response !== undefined && error.response.status === 401) {
                    window.location = getAuthenticationUrl();
                    return;
                }
                dispatch({
                    type: PartnerActionTypes.FETCH_PARTNER_FAILURE,
                    error: error.response
                });
                throw error;
            });
    };
}

export function GetEtablissementById(partnerId, etablissementId) {
    return (dispatch) => {
        dispatch({ type: PartnerActionTypes.FETCH_ETABLISSEMENT_REQUEST });
        return axios.get(PartnerUrl.etablissementByIdAndPartnerIdUrl(partnerId, etablissementId))
            .then((response) => {
                dispatch({
                    type: PartnerActionTypes.FETCH_ETABLISSEMENT_SUCCESS,
                    data: response.data
                });
            })
            .catch((error) => {
                if (error.response !== undefined && error.response.status === 401) {
                    window.location = getAuthenticationUrl();
                    return;
                }
                dispatch({
                    type: PartnerActionTypes.FETCH_ETABLISSEMENT_FAILURE,
                    error: error.response
                });
                throw error;
            });
    };
}

export function DownloadPrintFile(userId, guideNames) {
    return (dispatch) => {
        const guideDtos = [];
        guideNames.map(g => guideDtos.push({name: g.file}));
        dispatch({ type: ActionTypesBO.GENERATE_PRINT_REQUEST, data:userId  });
        return axios.post(userUrls.generatePrintFile(userId), guideDtos, { responseType: "arraybuffer" })
		.then((response) => {
			var file = new Blob([response.data], { type: response.headers["content-type"] });
			var fileurl = window.URL.createObjectURL(file);
			window.open(fileurl);
            dispatch({ type: ActionTypesBO.GENERATE_PRINT_SUCCESS});
		})
		.catch((error) => {
            dispatch({ type: ActionTypesBO.GENERATE_PRINT_FAILURE });
			if (error.response !== undefined && error.response.status === 401) {
				window.location = getAuthenticationUrl();
				return;
			}
			throw error;
		});
    }
};